import type { RuleGraphDto } from "@intelligems/ig-types";
import type { RuleGraphOverlaysByNodeId } from "../types";

/**
 * Nodes the Figma rows do not draw: the cart input only renders when it owns
 * a branchless lane header, and the output only appears once a scenario
 * result gives it something to say.
 */
export const hiddenRuleGraphNodeIds = (
  graph: RuleGraphDto,
  overlaysByNodeId?: RuleGraphOverlaysByNodeId,
  showInputHeader = false
): Set<string> => {
  const hidden = new Set<string>();
  for (const node of graph.nodes) {
    if (node.kind === "input" && !showInputHeader) {
      hidden.add(node.id);
    }
    if (
      node.kind === "output" &&
      overlaysByNodeId?.[node.id]?.result === undefined
    ) {
      hidden.add(node.id);
    }
  }
  return hidden;
};
